export default __webpack_public_path__ + "static/media/040-cruise.8f942231.svg";